import React, { useState } from 'react';
import { Calendar as CalendarIcon, Plus, X, Clock, MapPin, Users, Phone, Building2, Briefcase, Download, Filter, ChevronLeft, ChevronRight, RefreshCw, CalendarPlus } from 'lucide-react';
import { Calendar as BigCalendar, momentLocalizer, View } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
const localizer = momentLocalizer(moment);
interface CalendarEvent {
  id: string;
  title: string;
  start: Date;
  end: Date;
  type: 'meeting' | 'call' | 'visit' | 'deadline' | 'activity';
  location?: string;
  attendees?: string[];
  description?: string;
  color: string;
  completed?: boolean;
  priority?: 'high' | 'medium' | 'low';
}
interface Activity {
  id: string;
  title: string;
  completed: boolean;
  dueDate: string;
  priority: 'high' | 'medium' | 'low';
}
const mockEvents: CalendarEvent[] = [{
  id: '1',
  title: 'Sopralluogo Via Montenapoleone',
  start: new Date(2025, 0, 20, 10, 0),
  end: new Date(2025, 0, 20, 11, 30),
  type: 'visit',
  location: 'Via Montenapoleone 12, Milano',
  attendees: ['Marco Rossi', 'Laura Bianchi'],
  description: 'Sopralluogo con Luxury Fashion Brand per valutazione spazio retail',
  color: '#8b5cf6'
}, {
  id: '2',
  title: 'Call con Premium Lifestyle Co.',
  start: new Date(2025, 0, 22, 14, 0),
  end: new Date(2025, 0, 22, 15, 0),
  type: 'call',
  attendees: ['Giuseppe Verdi'],
  description: 'Discussione proposta commerciale per nuovo store',
  color: '#3b82f6'
}, {
  id: '3',
  title: 'Meeting Team Vendite',
  start: new Date(2025, 0, 23, 9, 0),
  end: new Date(2025, 0, 23, 10, 0),
  type: 'meeting',
  location: 'Sala Riunioni A',
  attendees: ['Team Vendite', 'Marco Rossi', 'Laura Bianchi'],
  description: 'Review settimanale pipeline e obiettivi Q1',
  color: '#10b981'
}, {
  id: '4',
  title: 'Firma Contratto - Jewelry Excellence',
  start: new Date(2025, 0, 24, 15, 0),
  end: new Date(2025, 0, 24, 16, 30),
  type: 'meeting',
  location: 'Via Montenapoleone 8',
  attendees: ['Andrea Ferrari', 'Legal Team'],
  description: 'Firma contratto di locazione per nuovo flagship store',
  color: '#10b981'
}, {
  id: '5',
  title: 'Presentazione Immobile',
  start: new Date(2025, 0, 27, 11, 0),
  end: new Date(2025, 0, 27, 12, 30),
  type: 'visit',
  location: 'Corso Buenos Aires 45',
  attendees: ['Elena Conti', 'Contemporary Art Gallery'],
  description: 'Presentazione spazio retail 200mq con vetrine su strada',
  color: '#8b5cf6'
}, {
  id: '6',
  title: 'Scadenza Documentazione',
  start: new Date(2025, 0, 28, 17, 0),
  end: new Date(2025, 0, 28, 17, 30),
  type: 'deadline',
  description: 'Invio documentazione contratto Armani - urgente',
  color: '#f59e0b'
}, {
  id: '7',
  title: 'Call Follow-up Swiss Watches',
  start: new Date(2025, 0, 29, 10, 0),
  end: new Date(2025, 0, 29, 10, 30),
  type: 'call',
  attendees: ['Roberto Martini'],
  description: 'Follow-up dopo sopralluogo, discussione condizioni contrattuali',
  color: '#3b82f6'
}, {
  id: '8',
  title: 'Sopralluogo Galleria Vittorio Emanuele',
  start: new Date(2025, 0, 30, 14, 0),
  end: new Date(2025, 0, 30, 16, 0),
  type: 'visit',
  location: 'Galleria Vittorio Emanuele II',
  attendees: ['Francesca Lombardi', 'High Fashion Brand'],
  description: 'Valutazione spazio premium 150mq in posizione strategica',
  color: '#8b5cf6'
}, {
  id: '9',
  title: 'Meeting Budget Q1',
  start: new Date(2025, 0, 31, 9, 30),
  end: new Date(2025, 0, 31, 11, 0),
  type: 'meeting',
  location: 'Sala Conferenze',
  attendees: ['Team Management', 'CFO'],
  description: 'Revisione budget e obiettivi primo trimestre 2025',
  color: '#10b981'
}];
const mockActivities: Activity[] = [{
  id: '1',
  title: 'Preparare presentazione per Luxury Fashion Brand',
  completed: false,
  dueDate: 'Oggi',
  priority: 'high'
}, {
  id: '2',
  title: 'Inviare contratto a Jewelry Excellence',
  completed: false,
  dueDate: 'Oggi',
  priority: 'high'
}, {
  id: '3',
  title: 'Follow-up con Premium Lifestyle Co.',
  completed: true,
  dueDate: 'Ieri',
  priority: 'medium'
}, {
  id: '4',
  title: 'Aggiornare CRM con nuovi contatti',
  completed: false,
  dueDate: 'Domani',
  priority: 'medium'
}, {
  id: '5',
  title: 'Revisionare proposta commerciale',
  completed: false,
  dueDate: '23 Gen',
  priority: 'low'
}];
const eventTypes = [{
  id: 'all',
  label: 'Tutti gli eventi',
  icon: CalendarIcon,
  color: '#1388ad'
}, {
  id: 'meeting',
  label: 'Meeting',
  icon: Users,
  color: '#10b981'
}, {
  id: 'call',
  label: 'Chiamate',
  icon: Phone,
  color: '#3b82f6'
}, {
  id: 'visit',
  label: 'Sopralluoghi',
  icon: Building2,
  color: '#8b5cf6'
}, {
  id: 'deadline',
  label: 'Scadenze',
  icon: Briefcase,
  color: '#f59e0b'
}];
const parseDueDate = (dueDate: string): Date => {
  const today = new Date();
  today.setHours(9, 0, 0, 0);
  if (dueDate === 'Oggi') {
    return today;
  } else if (dueDate === 'Ieri') {
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday;
  } else if (dueDate === 'Domani') {
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow;
  } else {
    const [day, month] = dueDate.split(' ');
    const monthMap: {
      [key: string]: number;
    } = {
      Gen: 0,
      Feb: 1,
      Mar: 2,
      Apr: 3,
      Mag: 4,
      Giu: 5,
      Lug: 6,
      Ago: 7,
      Set: 8,
      Ott: 9,
      Nov: 10,
      Dic: 11
    };
    const date = new Date(today.getFullYear(), monthMap[month], parseInt(day), 9, 0, 0, 0);
    return date;
  }
};
export function Calendar() {
  const [view, setView] = useState<View>('month');
  const [date, setDate] = useState(new Date());
  const [showNewEventModal, setShowNewEventModal] = useState(false);
  const [showSyncModal, setShowSyncModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState<CalendarEvent | null>(null);
  const [events] = useState<CalendarEvent[]>(mockEvents);
  const [selectedFilter, setSelectedFilter] = useState('all');
  const filteredEvents = selectedFilter === 'all' ? events : events.filter(event => event.type === selectedFilter);
  const handleNavigate = (newDate: Date) => {
    setDate(newDate);
  };
  const handleViewChange = (newView: View) => {
    setView(newView);
  };
  const toggleActivity = (id: string) => {
    setActivities(activities.map(activity => activity.id === id ? {
      ...activity,
      completed: !activity.completed
    } : activity));
  };
  const eventStyleGetter = (event: CalendarEvent) => {
    const isActivity = event.type === 'activity';
    const isCompleted = event.completed;
    let backgroundColor = '#64748b';
    if (isActivity) {
      backgroundColor = isCompleted ? '#94a3b8' : event.priority === 'high' ? '#ef4444' : event.priority === 'medium' ? '#f59e0b' : '#64748b';
    } else {
      const eventType = eventTypes.find(type => type.id === event.type);
      backgroundColor = eventType?.color || '#64748b';
    }
    return {
      style: {
        backgroundColor,
        borderRadius: '8px',
        opacity: isCompleted ? 0.5 : 0.95,
        color: 'white',
        border: isActivity ? '2px dashed rgba(255, 255, 255, 0.5)' : 'none',
        display: 'block',
        fontSize: '13px',
        fontWeight: '500',
        padding: '6px 10px',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        textDecoration: isCompleted ? 'line-through' : 'none'
      }
    };
  };
  const CustomToolbar = (toolbar: any) => {
    const goToBack = () => {
      toolbar.onNavigate('PREV');
    };
    const goToNext = () => {
      toolbar.onNavigate('NEXT');
    };
    const goToToday = () => {
      toolbar.onNavigate('TODAY');
    };
    const label = () => {
      const date = moment(toolbar.date);
      return <span className="text-lg font-semibold text-gray-900" data-id="element-455">
          {date.format('MMMM YYYY')}
        </span>;
    };
    return <div className="flex items-center justify-between mb-6 pb-4 border-b border-gray-200" data-id="element-456">
        <div className="flex items-center gap-3" data-id="element-457">
          <button onClick={goToToday} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-458">
            Oggi
          </button>
          <div className="flex items-center gap-1" data-id="element-459">
            <button onClick={goToBack} className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-460">
              <ChevronLeft className="w-5 h-5" data-id="element-461" />
            </button>
            <button onClick={goToNext} className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-462">
              <ChevronRight className="w-5 h-5" data-id="element-463" />
            </button>
          </div>
          {label()}
        </div>
        <div className="flex items-center gap-2" data-id="element-464">
          <button onClick={() => toolbar.onView('month')} className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${view === 'month' ? 'bg-[#1388ad] text-white' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-465">
            Mese
          </button>
          <button onClick={() => toolbar.onView('week')} className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${view === 'week' ? 'bg-[#1388ad] text-white' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-466">
            Settimana
          </button>
          <button onClick={() => toolbar.onView('day')} className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${view === 'day' ? 'bg-[#1388ad] text-white' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-467">
            Giorno
          </button>
        </div>
      </div>;
  };
  return <div className="space-y-6" data-id="element-468">
      <style data-id="element-469">{`
        .rbc-calendar {
          font-family: 'Source Sans 3', sans-serif;
        }
        .rbc-header {
          padding: 12px 8px;
          font-weight: 600;
          font-size: 13px;
          color: #6b7280;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          border-bottom: 1px solid #e5e7eb;
          background: #f9fafb;
        }
        .rbc-month-view {
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          overflow: hidden;
        }
        .rbc-month-row {
          border: none;
          min-height: 100px;
        }
        .rbc-day-bg {
          border-left: 1px solid #f3f4f6;
          border-top: 1px solid #f3f4f6;
        }
        .rbc-day-bg:first-child {
          border-left: none;
        }
        .rbc-today {
          background-color: #f0f9ff;
        }
        .rbc-off-range-bg {
          background-color: #fafafa;
        }
        .rbc-date-cell {
          padding: 8px;
          text-align: right;
        }
        .rbc-date-cell > a {
          color: #374151;
          font-weight: 500;
          font-size: 14px;
        }
        .rbc-today .rbc-date-cell > a {
          color: #1388ad;
          font-weight: 600;
        }
        .rbc-off-range .rbc-date-cell > a {
          color: #d1d5db;
        }
        .rbc-event {
          border: none !important;
          padding: 4px 8px;
          cursor: pointer;
        }
        .rbc-event:hover {
          opacity: 0.85;
        }
        .rbc-event-label {
          display: none;
        }
        .rbc-show-more {
          color: #1388ad;
          font-weight: 500;
          font-size: 12px;
          margin: 4px 8px;
          background: none;
          padding: 2px 0;
        }
        .rbc-show-more:hover {
          text-decoration: underline;
        }
        .rbc-time-view {
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          overflow: hidden;
        }
        .rbc-time-header {
          border-bottom: 1px solid #e5e7eb;
        }
        .rbc-time-content {
          border-top: none;
        }
        .rbc-time-slot {
          border-top: 1px solid #f3f4f6;
        }
        .rbc-current-time-indicator {
          background-color: #1388ad;
          height: 2px;
        }
        .rbc-timeslot-group {
          min-height: 60px;
          border-left: 1px solid #f3f4f6;
        }
        .rbc-day-slot .rbc-time-slot {
          border-top: 1px solid #f3f4f6;
        }
        .rbc-time-header-content {
          border-left: 1px solid #f3f4f6;
        }
        .rbc-allday-cell {
          background: #f9fafb;
        }
      `}</style>
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-470">
        <div data-id="element-471">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-472">Calendario</h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-473">
            Gestisci i tuoi appuntamenti e impegni
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-474">
          <button onClick={() => setShowSyncModal(true)} className="w-10 h-10 flex items-center justify-center border border-gray-300 text-gray-700 rounded-full hover:bg-gray-50 transition-colors" title="Sincronizza" data-id="element-475">
            <CalendarPlus className="w-5 h-5" data-id="element-476" />
          </button>
          <button onClick={() => setShowNewEventModal(true)} className="w-10 h-10 flex items-center justify-center bg-[#1388ad] text-white rounded-full hover:bg-[#0f6b8a] transition-colors" title="Nuovo Evento" data-id="element-477">
            <Plus className="w-5 h-5" data-id="element-478" />
          </button>
        </div>
      </div>
      {/* Main Content */}
      <div className="flex gap-6" data-id="element-479">
        {/* Sidebar */}
        <div className="hidden lg:block w-64 flex-shrink-0 space-y-6" data-id="element-480">
          {/* Filters */}
          <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-481">
            <div className="flex items-center gap-2 mb-4" data-id="element-482">
              <Filter className="w-4 h-4 text-gray-500" data-id="element-483" />
              <h3 className="text-sm font-semibold text-gray-900" data-id="element-484">
                Filtra per tipo
              </h3>
            </div>
            <div className="space-y-2" data-id="element-485">
              {eventTypes.map(type => {
              const Icon = type.icon;
              const count = type.id === 'all' ? events.length : events.filter(e => e.type === type.id).length;
              return <button key={type.id} onClick={() => setSelectedFilter(type.id)} className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-colors ${selectedFilter === type.id ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-486">
                    <div className="flex items-center gap-3" data-id="element-487">
                      <div className="w-2 h-2 rounded-full" style={{
                    backgroundColor: type.color
                  }} data-id="element-488" />
                      <Icon className="w-4 h-4" data-id="element-489" />
                      <span className="text-sm font-normal" data-id="element-490">{type.label}</span>
                    </div>
                    <span className="text-xs text-gray-500" data-id="element-491">{count}</span>
                  </button>;
            })}
            </div>
          </div>
        </div>
        {/* Mobile Filter Dropdown */}
        <div className="lg:hidden w-full mb-4" data-id="element-492">
          <select value={selectedFilter} onChange={e => setSelectedFilter(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad] bg-white text-sm" data-id="element-493">
            {eventTypes.map(type => {
            const count = type.id === 'all' ? events.length : events.filter(e => e.type === type.id).length;
            return <option key={type.id} value={type.id} data-id="element-494">
                  {type.label} ({count})
                </option>;
          })}
          </select>
        </div>
        {/* Calendar */}
        <div className="flex-1 bg-white border border-gray-200 rounded-lg p-6" data-id="element-495">
          <div style={{
          height: '700px'
        }} data-id="element-496">
            <BigCalendar localizer={localizer} events={filteredEvents} startAccessor="start" endAccessor="end" view={view} onView={handleViewChange} date={date} onNavigate={handleNavigate} eventPropGetter={eventStyleGetter} onSelectEvent={event => setSelectedEvent(event)} components={{
            toolbar: CustomToolbar
          }} messages={{
            next: 'Avanti',
            previous: 'Indietro',
            today: 'Oggi',
            month: 'Mese',
            week: 'Settimana',
            day: 'Giorno',
            agenda: 'Agenda'
          }} data-id="element-497" />
          </div>
        </div>
      </div>
      {/* Event Detail Modal */}
      {selectedEvent && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-498">
          <div className="bg-white w-full max-w-lg rounded-lg" data-id="element-499">
            <div className="p-6 border-b border-gray-200 flex items-center justify-between" data-id="element-500">
              <h2 className="text-xl font-semibold text-gray-900" data-id="element-501">
                Dettagli Evento
              </h2>
              <button onClick={() => setSelectedEvent(null)} className="p-2 hover:bg-gray-100 transition-colors rounded-lg" data-id="element-502">
                <X className="w-5 h-5 text-gray-500" data-id="element-503" />
              </button>
            </div>
            <div className="p-6 space-y-4" data-id="element-504">
              <div data-id="element-505">
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-506">
                  {selectedEvent.title}
                </h3>
                {selectedEvent.description && <p className="text-sm text-gray-600" data-id="element-507">
                    {selectedEvent.description}
                  </p>}
              </div>
              <div className="flex items-center gap-3 text-sm text-gray-600" data-id="element-508">
                <Clock className="w-4 h-4" data-id="element-509" />
                <span data-id="element-510">
                  {moment(selectedEvent.start).format('DD MMM YYYY, HH:mm')} -{' '}
                  {moment(selectedEvent.end).format('HH:mm')}
                </span>
              </div>
              {selectedEvent.location && <div className="flex items-center gap-3 text-sm text-gray-600" data-id="element-511">
                  <MapPin className="w-4 h-4" data-id="element-512" />
                  <span data-id="element-513">{selectedEvent.location}</span>
                </div>}
              {selectedEvent.attendees && selectedEvent.attendees.length > 0 && <div className="flex items-start gap-3 text-sm text-gray-600" data-id="element-514">
                    <Users className="w-4 h-4 mt-0.5" data-id="element-515" />
                    <div data-id="element-516">
                      <p className="font-medium text-gray-700 mb-1" data-id="element-517">
                        Partecipanti:
                      </p>
                      <ul className="space-y-1" data-id="element-518">
                        {selectedEvent.attendees.map((attendee, idx) => <li key={idx} data-id="element-519">{attendee}</li>)}
                      </ul>
                    </div>
                  </div>}
            </div>
            <div className="p-6 border-t border-gray-200 flex gap-3" data-id="element-520">
              <button onClick={() => setSelectedEvent(null)} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-521">
                Chiudi
              </button>
              <button className="flex-1 px-4 py-2 bg-[#1388ad] text-white rounded-lg hover:bg-[#0f6b8a] transition-colors" data-id="element-522">
                Modifica
              </button>
            </div>
          </div>
        </div>}
      {/* Sync Modal */}
      {showSyncModal && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-523">
          <div className="bg-white w-full max-w-md rounded-lg" data-id="element-524">
            <div className="p-6 border-b border-gray-200 flex items-center justify-between" data-id="element-525">
              <h2 className="text-xl font-semibold text-gray-900" data-id="element-526">
                Sincronizza Calendario
              </h2>
              <button onClick={() => setShowSyncModal(false)} className="p-2 hover:bg-gray-100 transition-colors rounded-lg" data-id="element-527">
                <X className="w-5 h-5 text-gray-500" data-id="element-528" />
              </button>
            </div>
            <div className="p-6 space-y-4" data-id="element-529">
              <p className="text-sm text-gray-600 mb-4" data-id="element-530">
                Connetti il tuo calendario per sincronizzare automaticamente gli
                appuntamenti
              </p>
              <button className="w-full flex items-center justify-center gap-3 px-4 py-3 border-2 border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-531">
                <img src="https://www.google.com/favicon.ico" alt="Google" className="w-5 h-5" data-id="element-532" />
                <span className="font-medium text-gray-900" data-id="element-533">
                  Sincronizza con Google Calendar
                </span>
              </button>
              <button className="w-full flex items-center justify-center gap-3 px-4 py-3 border-2 border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-534">
                <img src="https://www.microsoft.com/favicon.ico" alt="Microsoft" className="w-5 h-5" data-id="element-535" />
                <span className="font-medium text-gray-900" data-id="element-536">
                  Sincronizza con Outlook
                </span>
              </button>
              <div className="pt-4 border-t border-gray-200" data-id="element-537">
                <p className="text-xs text-gray-500" data-id="element-538">
                  La sincronizzazione è bidirezionale: gli eventi creati qui
                  appariranno nel tuo calendario e viceversa.
                </p>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200" data-id="element-539">
              <button onClick={() => setShowSyncModal(false)} className="w-full px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-540">
                Chiudi
              </button>
            </div>
          </div>
        </div>}
      {/* New Event Modal */}
      {showNewEventModal && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-541">
          <div className="bg-white w-full max-w-lg rounded-lg max-h-[90vh] overflow-y-auto" data-id="element-542">
            <div className="sticky top-0 bg-white p-6 border-b border-gray-200 flex items-center justify-between" data-id="element-543">
              <h2 className="text-xl font-semibold text-gray-900" data-id="element-544">
                Nuovo Evento
              </h2>
              <button onClick={() => setShowNewEventModal(false)} className="p-2 hover:bg-gray-100 transition-colors rounded-lg" data-id="element-545">
                <X className="w-5 h-5 text-gray-500" data-id="element-546" />
              </button>
            </div>
            <div className="p-6 space-y-4" data-id="element-547">
              <div data-id="element-548">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-549">
                  Titolo
                </label>
                <input type="text" placeholder="Es. Meeting con cliente" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-550" />
              </div>
              <div data-id="element-551">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-552">
                  Tipo di Evento
                </label>
                <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-553">
                  <option value="meeting" data-id="element-554">Meeting</option>
                  <option value="call" data-id="element-555">Chiamata</option>
                  <option value="visit" data-id="element-556">Sopralluogo</option>
                  <option value="deadline" data-id="element-557">Scadenza</option>
                </select>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-558">
                <div data-id="element-559">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-560">
                    Data Inizio
                  </label>
                  <input type="datetime-local" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-561" />
                </div>
                <div data-id="element-562">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-563">
                    Data Fine
                  </label>
                  <input type="datetime-local" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-564" />
                </div>
              </div>
              <div data-id="element-565">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-566">
                  Luogo
                </label>
                <input type="text" placeholder="Es. Via Montenapoleone 12, Milano" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-567" />
              </div>
              <div data-id="element-568">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-569">
                  Partecipanti
                </label>
                <input type="text" placeholder="Aggiungi partecipanti" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-570" />
              </div>
              <div data-id="element-571">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-572">
                  Descrizione
                </label>
                <textarea rows={3} placeholder="Dettagli aggiuntivi..." className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad] resize-none" data-id="element-573" />
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex gap-3" data-id="element-574">
              <button onClick={() => setShowNewEventModal(false)} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-575">
                Annulla
              </button>
              <button className="flex-1 px-4 py-2 bg-[#1388ad] text-white rounded-lg hover:bg-[#0f6b8a] transition-colors" data-id="element-576">
                Crea Evento
              </button>
            </div>
          </div>
        </div>}
    </div>;
}